import { createServerFn } from "@tanstack/react-start";
import { readDocumentPage } from "./document.server";
import { readNativeHome } from "./home.server";
import {
  privateResponse,
  publicationResponse,
  shareableResponse,
  siteContext,
} from "./site.server";
import { listPublishedCreatorPages } from "../../../api/src/pages/service";
import { viewerAudience } from "../../../api/src/pages/audience";
import { memberHomepagePath } from "../../../shared/src/page-updates-runtime";

/**
 * Home (/) in one request: the creator's composed Home page, or the native home built from their
 * template. Drate's own host answers "platform" and its route draws the marketing home.
 */
export const loadHome = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (!drate.creator) return { kind: "platform" as const };
  const header = drate.creator.customization?.header;
  // The editor always opens the selected Home document; live members use their chosen landing.
  if (header?.memberHomePath && !drate.customizationPreview) {
    const to = memberHomepagePath(
      header,
      await viewerAudience(drate, drate.creator.id),
      (await listPublishedCreatorPages(drate)).map((page) => page.path),
    );
    if (to !== "/") {
      privateResponse();
      return { kind: "redirect" as const, to };
    }
  }
  const page = await readDocumentPage(drate, "/");
  if (page.kind === "redirect" || page.kind === "page") return page;
  // A creator's native Home may be kept at the edge for anonymous visitors.
  shareableResponse();
  const home = await readNativeHome(drate);
  publicationResponse(drate);
  return { kind: "home" as const, home };
});
